export default "__VITE_ASSET__CGCb8iUi__"